import {
  StoragePlaceKinds,
} from ".";
import {
  ElementTypes
} from "./objects";
import {
  IPoint,
  ISize,
} from "../../../base/domain/drawing";
import {
  IEntity,
  INameSpecifiable,
  IEditionSpecifiable,
  IVersionSpecifiable,
} from "../../../base/domain/entity";
import {
  IDateDuration,
} from "../../../base/domain/system";
import {
  IStructuredPage,
  IStructuredDocument,
} from "../../../base/domain/system/document";
import {
  INameHistorySpecifiable, instanceOfINameHistorySpecifiable,
  IBookmarkSpecifiable, instanceOfIBookmarkSpecifiable, IInformationKeySpecifiable,
} from "../../../documaker/domain/format/objects";
import { IFormatAlert } from "./IFormatAlert";

export interface IEditableFormatObject extends IEntity<number>, INameSpecifiable, INameHistorySpecifiable, IInformationKeySpecifiable, IBookmarkSpecifiable {
  elementName: ElementTypes;
  _source?: any;              // 元になったbeanを格納する.書き戻し時の初期値やdebugでの利用を想定.
}

export function instanceOfIEditableFormatObject(instance: any): instance is IEditableFormatObject {
  return instance
      && (instance.elementName !== undefined)
      && instanceOfINameHistorySpecifiable(instance)
      && instanceOfIBookmarkSpecifiable(instance);
}

export function instanceOfEditableFormatObject<T extends IEditableFormatObject>(instance: any, name: ElementTypes): instance is T {
  return instanceOfIEditableFormatObject(instance)
      && (instance.elementName === name);
}

export interface IEditableFormatPageStructure extends IStructuredPage<IEditableFormatObject> {
  pageKey: number;
  image: IEditableFormatImage;
  layer: IEditableFormatLayer;
  shouldPrint: boolean;
  shouldPrintOnFirstRegistered: boolean;
  editingOnly: boolean;
}

export interface IEditableFormatImage {
  location: IPoint;
  size: ISize;
}

export interface IEditableFormatLayer {
  formatId: number;
  sectionNo: number;
  imageGuid: string;
  location: IPoint;
  size: ISize;
  fileName: string;
}

export interface IEditableFormatStructure extends IEntity<number>, IStructuredDocument<IEditableFormatPageStructure, IEditableFormatObject>, INameSpecifiable, IEditionSpecifiable, IVersionSpecifiable<string> {
  documentKindId: number;
  companyCode: string;
  masterCode: string;
  expirationDate: IDateDuration;
  numberOfPrints: number;
  indicationMagnification: number;
  categoryType: string;
  tag: string;
  inOutType: string;
  referenceFiles: IEditableFormatReferenceFile[];
  lastMaxObjectId: number;
  maxPageKey: number;
  lastUpdated: IUpdateInformation;
  isDeleted: boolean;
  archiveId?: number;                             // 過去版を更新する事はありえないので値が入る事はないと思うが...
  copiedFormat: IFormatIndetifier;
  writeMethodType: WriteMethodKinds;
  settings: IEditableFormatSetting;
  questionnaire: IEditableFormatQuestionnaire;    // Questionnaire拡張.通常は使わない.
  alerts?: IFormatAlert[];                        // 登録時に警告があればタブを選択状態にするために利用
}

export interface IUpdateInformation {
  dateTime: Date;
  userName: string;
}

export interface IFormatIndetifier {
  id: number;
  archiveId: number;
}

export interface IEditableFormatReferenceFile {
  key: string;
  name: string;
  storagePlace: StoragePlaceKinds;
}

export enum WriteMethodKinds {
  Unknown = 0,      // 未指定.
  Direct = 1,       // 直接記載.(ユーザ確認後突破可能.)
  Workflow = 2,     // ワークフロー.(ユーザ確認後突破可能.)
  DirectOnly = 3,   // 直接記載.(ワークフロー記載不可.)
  WorkflowOnly = 4, // ワークフロー.(直接記載不可.)
}

export interface IEditableFormatSetting {
  nameAlert: IEditableFormatAlertSetting;
}

export interface IEditableFormatAlertSetting {
  names: string | string[];
}

export interface IEditableFormatQuestionnaire {
  resourceType: string;
  version: string;
  status: string;
  publisher: string;
  experimental: boolean;
  copyright: string;
  subjectTypes: string[];
}
